<template>
  <CModal
    class="modal__footer-empty confirmation-modal"
    :title="contents.title"
    centered
    :show="show"
    @update:show="closeModal"
  >
    <p class="text-center py-2" v-if="!contents.loading" v-html="contents.body"></p>
    <LoaderComponent v-if="contents.loading" />

    <button
      :class="buttonColor"
      class="btn float-right"
      :disabled="loading"
      v-if="contents.buttonText"
      @click="onClickButton"
      >
      {{ contents.buttonText }}
    </button>
  </CModal>
</template>

<script>
import {
  createModalMixin,
  modalStore
} from '@/mixins/modalsMixin'
import LoaderComponent from '../LoaderComponent.vue';

export default {
  name: 'TheConfirmationModal',

  mixins: [createModalMixin()],
  components:{
    LoaderComponent,
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loading: false,
    };
  },
  computed: {
    contents() {
      return this[modalStore.getterTypes.GETTER_OPENED_CONFIRMATION_MODAL_CONTENTS] || {}
    },
    buttonColor() {
      return this.contents.buttonPrimary ? 'btn-primary' : 'btn-danger'
    }
  },

  methods: {
    onClickButton() {
      this.loading = true
      if (this.contents.onClickButton && typeof this.contents.onClickButton === 'function') {
        this.contents.onClickButton()
      }
      this.closeModal(); 
    },
    closeModal() {
      this.loading = false
      this.$emit('close')
    },
  },
  mounted(){
    this.loading = false
    console.log("mounted")
  }
}
</script>
